var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 3,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H22C23.6569 0 25 1.34315 25 3V7H0V3Z",
    fill: "#E86247"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 15,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 20,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 15,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 20,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 10,
    width: 2,
    height: 2,
    fill: "#707070"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 15,
    width: 2,
    height: 2,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8fef4943b12ff29854929a4448069cc5.svg";
export { ForwardRef as ReactComponent };